import { render, staticRenderFns } from "./IsNeedCallback.vue?vue&type=template&id=5be5bd01&scoped=true"
import script from "./IsNeedCallback.vue?vue&type=script&lang=js"
export * from "./IsNeedCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be5bd01",
  null
  
)

export default component.exports